var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logo w-spc3 inline-block",attrs:{"to":"/"}},[_c('img',{staticClass:"w-full",attrs:{"src":require('@/assets/images/logo.png'),"alt":"Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }